/**
 * @generated SignedSource<<9714a69259e425e9adaa03e540ebc838>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSearchForm_defaultArrivalAirport$data = {
  readonly code: string;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "FlightSearchForm_defaultArrivalAirport";
};
export type FlightSearchForm_defaultArrivalAirport$key = {
  readonly " $data"?: FlightSearchForm_defaultArrivalAirport$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSearchForm_defaultArrivalAirport">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightSearchForm_defaultArrivalAirport",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "type": "Airport",
  "abstractKey": null
};

(node as any).hash = "bbc1c46b4b378decb018aefc6e51f96f";

export default node;
